import { useState, useEffect } from 'react';

import { MatchStatusType, PREMATCH } from '../../../typings/match';

const ONE_HOUR_IN_MS = 3_600_000;

interface IUseShouldRenderCountdown {
  status: MatchStatusType;
  startDate?: string;
  enabled?: boolean;
}

export function useShouldRenderMatchCountdown({
  status,
  startDate,
  enabled,
}: IUseShouldRenderCountdown): [boolean, boolean] {
  const [timeoutPassed, setTimeoutPassed] = useState(false);
  const startDateInMS = Number(Date.parse(startDate ?? ''));

  useEffect(() => {
    const timeout = setTimeout(() => setTimeoutPassed(true), 5_000);
    return () => clearTimeout(timeout);
  }, []);

  if (Number.isNaN(startDateInMS) || !enabled) {
    return [false, false];
  }

  const isPrematch = status === PREMATCH;
  const isBeforeMatch = Date.now() > startDateInMS - ONE_HOUR_IN_MS;
  const isOneHourBeforeMatch = isPrematch && isBeforeMatch;

  return [isOneHourBeforeMatch, isOneHourBeforeMatch && timeoutPassed];
}

export function useAnimateCountdown(duration: number, initial = false): [boolean, boolean] {
  const [shouldAnimate, setShouldAnimate] = useState(initial);
  const matchStarted = duration < -5000;

  useEffect(() => {
    if (duration < 2000 && duration > 1000) {
      setShouldAnimate(false);
    }

    if (duration <= 0) {
      setShouldAnimate(true);
    }
  }, [duration]);

  return [shouldAnimate, matchStarted];
}
